<div
  class="fridge-info"
  [class.with-version]="!!tabletVersion"
  (click)="onFridgeSelect(fridge._id)"
>
  <div class="fridge-info__main">
    <span class="fridge-info__id">#{{ fridge.inventoryNumber }}</span>

    <div class="fridge-info__status" [class.online]="fridge.connected" [class.offline]="!fridge.connected">
      <span class="status-dot"></span>
      {{ fridge.connected ? ('home.online' | translate) : ('home.offline' | translate) }}
    </div>

    <div class="fridge-info__icons">
      @if (fridge.connected && fridge.stateMachine?.state === 'Error') {
        <div [id]="fridge._id" class="fridge-error" [title]="'home.temp_alert' | translate">
          <img src="./assets/icon/fridge-error.svg" />
        </div>
      }
      @if (fridge.stopSale?.active || fridge.factoryMode?.active) {
        <div class="stop-sale-error" [title]="'home.stop_sale' | translate">
          <img src="../../../assets/icon/stop-sale.svg" />
        </div>
      }
      @if (fridge.connected && fridge.subSystemsState?.Tablet !== FridgeSubSystemState.Ok) {
        <div class="fridge-error" [title]="'home.tablet_error' | translate">
          <img src="../../../assets/icon/tablet-error.svg" />
        </div>
      }
      @if (fridge.connected && fridge.stateMachine?.state === 'Error') {
        <ion-popover
          [trigger]="fridge._id"
          [showBackdrop]="false"
          [arrow]="true"
          alignment="center"
          trigger-action="hover"
          >
          <ng-template>
            <div class="error">{{ fridge.stateMachine?.reason || 'ERROR' }}</div>
          </ng-template>
        </ion-popover>
      }
    </div>
  </div>

  @if (merchantName !== '') {
    <p class="fridge-info__merchant">{{ merchantName }}</p>
  }
  <p class="fridge-info__address">{{ fridge.address }}</p>

  @if (!fridge.connected && fridge.disconnectedAt) {
    <p class="fridge-info__last-seen">
      {{ 'home.last_seen' | translate }}: {{ fridge.disconnectedAt | date : 'MMM d, y' }}
      {{ 'home.at' | translate }} {{ fridge.disconnectedAt | date : 'HH:mm' }}
    </p>
  }

  @if (tabletVersion) {
    <span class="fridge-info__version" [title]="'home.tablet_version' | translate">
      v{{ tabletVersion }}
    </span>
  }
</div>
